import { URL_REPLACEMENT } from '$const';
import { post } from '~services/api/methods';

export type PostNewsletterDto = {
  changeLogIds: number[];
  description: string;
  langcode?: string;
};

export async function postNewsletter(data: PostNewsletterDto) {
  const requestUrl = `${URL_REPLACEMENT.BACKEND_URL}/api/ebm/changelog/newsletters`;
  const response = await post<boolean, PostNewsletterDto>(requestUrl, data);
  return response;
}
